module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "party"
  }, [(_vm.isSigner) ? [_c('div', {
    staticClass: "party__is-signer"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('parties.signer')) + "\n    ")])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "party__icon"
  }, [_c('icon', {
    attrs: {
      "name": "user",
      "height": "38",
      "width": "38"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "party__info"
  }, [_c('div', {
    class: ("party__info__header " + (_vm.hideEmail ? 'party__info__header--large' : ''))
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (!_vm.hideEmail) ? _c('div', {
    staticClass: "party__info__subheader"
  }, [_vm._v(_vm._s(_vm.email))]) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9ba08e0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Parties.vue
// module id = 1065
// module chunks = 1